import React from "react";
import { useRouter } from "next/navigation";
import { Button as ButtonLib } from "@npm_leadtech/qr-ui-components";
import { Typography } from "@/components/Typography";
import { Banner } from "@/components/Banner";
import { BannerWrapperSize } from "@/components/Banner/types";
import { bannerProps } from "@/data/types/home";
import { paths } from "@/utils/paths";

import "./styles.scss";

export const MoreModule = ({
  data,
  wrapperSize,
}: {
  data: bannerProps;
  wrapperSize: BannerWrapperSize;
}) => {
  const { ctaLabel, richtext, data_qa } = data;

  const router = useRouter();
  const handleMoreClick = () => {
    router.push(paths.faq());
  };

  return (
    <Banner
      big
      light
      wrapperSize={wrapperSize}>
      {richtext.map((item, i: number) => (
        <Typography
          key={i}
          Tag={item.tag}
          size={item.size}
          spacing={item.spacing}>
          {item.list
            ? item.list.map((e, i) => (
                <li key={i}>{<span dangerouslySetInnerHTML={{ __html: e["item"] }}></span>}</li>
              ))
            : item.content}
        </Typography>
      ))}

      <div className="buttonWrapper cta-more">
        <ButtonLib
          dataQA={data_qa}
          onClick={handleMoreClick}
          label={ctaLabel}
          variant="secondary"
        />
      </div>
    </Banner>
  );
};
